import { getDataTable } from '../../features/visual-analytics/charts/chartDataBindings';
import { getColumnInfo } from '../analyticsDataSlice';
import { TpCanonicalTypeInfo, TpDataContext } from '../interfaces';
import {
  TpActiveEnSelectionFilter,
  TpEnSelectionFilterDefinition,
  TpEnSelectionFilterStep,
  TpEnSelectionFilterStepLasso2D,
  TpEnSelectionFilterTypes,
} from './interfaces';
import { getEnSelectionFilterStep } from './selectionEnFilters';
import { TpUserEnSelectionAction, TpUserEnSelectionActionLasso2D } from './userSelectionActions';

function getLasso2DEnFilterStepKey(dataTableId: string, colIdX: string, colIdY: string): string {
  return `numericalRange_${dataTableId}_${colIdX}_${colIdY}`;
}

export function getLasso2DEnFilterStep(
  selectionFilter: TpActiveEnSelectionFilter,
  dataTableId: string,
  colIdX: string,
  colIdY: string,
): TpEnSelectionFilterStepLasso2D | null {
  const step = getEnSelectionFilterStep(selectionFilter, getLasso2DEnFilterStepKey(dataTableId, colIdX, colIdY));
  if (!step) return null;
  return step as TpEnSelectionFilterStepLasso2D;
}

function handleUserAction(
  state: any,
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  userSelectionAction: TpUserEnSelectionAction,
) {
  const userSelectionActionLasso2D = userSelectionAction as TpUserEnSelectionActionLasso2D;
  const key = getLasso2DEnFilterStepKey(
    userSelectionActionLasso2D.dataTableId,
    userSelectionActionLasso2D.colIdX,
    userSelectionActionLasso2D.colIdY,
  );
  const step = getEnSelectionFilterStep(canonicalTypeInfo.selectionFilter, key);
  let stepLasso2D: TpEnSelectionFilterStepLasso2D;
  if (!step) {
    stepLasso2D = {
      type: TpEnSelectionFilterTypes.LASSO2D,
      key,
      dataTableId: userSelectionActionLasso2D.dataTableId,
      colIdX: userSelectionActionLasso2D.colIdX,
      colIdY: userSelectionActionLasso2D.colIdY,
      lassoPoints: userSelectionActionLasso2D.lassoPoints,
      selectedItemIds: userSelectionActionLasso2D.selectedItemIds,
    };
    canonicalTypeInfo.selectionFilter.steps.push(stepLasso2D);
  } else {
    // @todo: possible improvement: choice of set logic for addition (replace, add, intersect, exclude)
    stepLasso2D = step as TpEnSelectionFilterStepLasso2D;
    stepLasso2D.lassoPoints = userSelectionActionLasso2D.lassoPoints;
    stepLasso2D.selectedItemIds = userSelectionActionLasso2D.selectedItemIds;
  }
}

function performStep(
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  step: TpEnSelectionFilterStep,
): any[] {
  const stepLasso2D = step as TpEnSelectionFilterStepLasso2D;
  return stepLasso2D.selectedItemIds;
}

function renderContent(
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  step: TpEnSelectionFilterStep,
  forceString?: boolean,
) {
  const stepLasso2D = step as TpEnSelectionFilterStepLasso2D;
  const dataTable = getDataTable(dataContext, stepLasso2D.dataTableId);
  const colInfoX = getColumnInfo(dataTable, stepLasso2D.colIdX);
  const colInfoY = getColumnInfo(dataTable, stepLasso2D.colIdY);

  if (forceString) return `${colInfoX.name},${colInfoY.name}: lasso selection`;

  return (
    <span>
      <b>
        {colInfoX.name}, {colInfoY.name}
      </b>
      : lasso selection
    </span>
  );
}

export const defEnSelectionFilterLasso2D: TpEnSelectionFilterDefinition = {
  handleUserAction,
  performStep,
  renderContent,
};
